import { useRef, useState } from "react";
import { motion, useInView, useMotionValue, useReducedMotion, useSpring } from "framer-motion";
import { ArrowUpRight, X } from "lucide-react";
import { TRACK_RECORD } from "@/lib/track-record";
import "./FinalSections.css";

export const FounderRecord = () => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const entered = useInView(ref, { once: true, amount: .4 });
  const reducedMotion = useReducedMotion();
  const tiltX = useMotionValue(0);
  const tiltY = useMotionValue(0);
  const rotateX = useSpring(tiltX, { stiffness: 160, damping: 24 });
  const rotateY = useSpring(tiltY, { stiffness: 160, damping: 24 });
  const resetTilt = () => { tiltX.set(0); tiltY.set(0); };
  const move = (event) => {
    if (reducedMotion || open || event.pointerType !== "mouse") return;
    const rect = event.currentTarget.getBoundingClientRect();
    tiltX.set(((event.clientY - rect.top) / rect.height - .5) * -8);
    tiltY.set(((event.clientX - rect.left) / rect.width - .5) * 10);
  };

  return (
    <div ref={ref} className="founder-record" data-open={open} data-entered={entered}>
      <div className="founder-record-stage" onPointerMove={move} onPointerLeave={resetTilt}>
        <motion.div className="founder-record-book" style={{ rotateX: reducedMotion ? 0 : rotateX, rotateY: reducedMotion ? 0 : rotateY }}>
          <div id="founder-record-pages" className="founder-record-pages" aria-hidden={!open} inert={!open}>
            <p className="record-page-heading font-display">Closed revenue.</p>
            <ul>
              {TRACK_RECORD.map(record => (
                <li key={record.name}>
                  <span className="record-company">{record.wordmark}</span>
                  <strong className="record-revenue font-display">{record.metric}</strong>
                  <span className="record-revenue-label">{record.metricLabel}</span>
                </li>
              ))}
            </ul>
            <a href="#results" className="record-campaign-link">View the campaigns <ArrowUpRight size={18} aria-hidden="true" /></a>
          </div>
          <div className="founder-record-cover" aria-hidden={open}>
            <img src="/logo-white.png" alt="GTM Consultancy" />
            <div className="record-cover-name">
              <span className="font-editorial italic">Hamza<br />Ahmed</span>
              <svg viewBox="0 0 300 24" aria-hidden="true"><path pathLength="1" d="M 4 16 C 64 2 120 25 173 10 C 222 0 265 19 296 9" /></svg>
            </div>
            <p>Founder. Closer. Operator.</p>
            <span className="record-cover-corner" aria-hidden="true"><ArrowUpRight size={34} /></span>
          </div>
        </motion.div>
      </div>
      <button type="button" className="founder-record-toggle" aria-expanded={open} aria-controls="founder-record-pages" onClick={() => { resetTilt(); setOpen(value => !value); }}>
        {open ? "Close the track record" : "Open the track record"}
        {open ? <X size={20} aria-hidden="true" /> : <ArrowUpRight size={20} aria-hidden="true" />}
      </button>
    </div>
  );
};
